import React, { createContext, useCallback, useContext, useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { BRAND } from './brand';

export const DEFAULT_SETTINGS = {
  address: BRAND.addressLines.join('\n'),
  telephone: BRAND.phone,
  themeColor: BRAND.colors.primary,
};
const SETTINGS_URL = 'https://serverkf.ccsoftwares.com/settings';
export const SettingsContext = createContext({ settings: DEFAULT_SETTINGS, loading: false, error: '' });
export const useSettings = () => useContext(SettingsContext);

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULT_SETTINGS);
  const [loading, setLoading] = useState(true);
  const [initialized, setInitialized] = useState(false);
  const [error, setError] = useState('');
  const loadVersion = useRef(0);

  const reloadSettings = useCallback(async () => {
    const version = ++loadVersion.current;
    setLoading(true);
    setError('');
    try {
      const { data } = await axios.get(SETTINGS_URL, { timeout: 10000 });
      if (version === loadVersion.current) setSettings(data);
    } catch (err) {
      if (version === loadVersion.current) {
        setError(err.response?.data?.error || 'Unable to load settings. Check the server connection and try again.');
      }
    } finally {
      if (version === loadVersion.current) {
        setLoading(false);
        setInitialized(true);
      }
    }
  }, []);

  useEffect(() => { reloadSettings(); }, [reloadSettings]);

  const saveSettings = async values => {
    const { data } = await axios.put(SETTINGS_URL, values);
    setSettings(data);
    setError('');
    return data;
  };

  return <SettingsContext.Provider value={{ settings, loading, initializing: !initialized, error, reloadSettings, saveSettings }}>
    {children}
  </SettingsContext.Provider>;
}
